import { cn } from "@/shared/lib/utils";

type AmbientGradientProps = {
  position?: "hero" | "closing"
  className?: string
};

const AmbientGradient = ({ position = "hero", className }: AmbientGradientProps) => {
  return (
    <div
      aria-hidden="true"
      className={cn(
        "pointer-events-none absolute inset-x-0 z-0 overflow-hidden",
        position === "hero" ? "-top-32 h-[640px]" : "-bottom-40 h-[560px]",
        className,
      )}
    >
      <div
        className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        style={{
          width: "min(1200px, 110vw)",
          height: "min(720px, 80vh)",
          background: position === "hero"
            ? "radial-gradient(60% 55% at 50% 35%, rgba(196, 181, 253, 0.55) 0%, rgba(244, 242, 255, 0.6) 35%, rgba(255,255,255,0) 70%)"
            : "radial-gradient(55% 50% at 50% 60%, rgba(196, 181, 253, 0.42) 0%, rgba(244, 242, 255, 0.5) 38%, rgba(255,255,255,0) 72%)",
          filter: "blur(40px)",
        }}
      />
      <div
        className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        style={{
          width: "min(800px, 70vw)",
          height: "min(420px, 50vh)",
          background: "radial-gradient(50% 50% at 50% 50%, rgba(45, 212, 191, 0.12) 0%, rgba(45, 212, 191, 0) 70%)",
          filter: "blur(60px)",
          transform: position === "hero"
            ? "translate(-30%, -30%)"
            : "translate(30%, 10%)",
        }}
      />
    </div>
  );
};

export default AmbientGradient;
